import { graphql, useStaticQuery } from "gatsby"
import * as React from "react"
import Widget from "../../components/Widget"

import * as styles from './styles.module.scss'

const GET_WIDGETS = graphql`
  query {
    allGoogleSpreadsheetBoxing {
      nodes {
        id
        date
        firstTeam
        firstTeamFlag
        firstWinnerCoef
        secondTeam
        secondTeamFlag
        secondWinnerCoef
        time
        drawCoef
        link
        hide
      }
    }
  }
`

const BoxingWidgets = () => {
  const { allGoogleSpreadsheetBoxing: data } = useStaticQuery(GET_WIDGETS)

  const content = React.useMemo(() => { 
    if(data.nodes.length === 1) {
      return null
    }

    const visibleWidgets = data.nodes.filter((widget: any) => widget.hide !== 'TRUE')

    return (
      <div className={styles.widgets}>
        {visibleWidgets.map((widget: any) => <Widget {...widget} key={widget.id} />)}
      </div>
    )
  }, [data])

  return content
}

export default BoxingWidgets